import { DetailTabModel } from '@y42/feature/detail-view';
import { agGridJobIcon, agGridOrchestrationIcon } from '@y42/feature/icons';

export const OrchestrationTabs: DetailTabModel[] = [
  {
    path: 'structure',
    logo: agGridOrchestrationIcon,
    label: 'Orchestration setup',
    description: 'Edit the structure of this orchestration',
  },
  {
    path: 'overview',
    logo: agGridJobIcon,
    label: 'Jobs',
    description: 'Get a job overview of this orchestration',
  },
];
